// Debug logging, shown only when REACT_APP_DEBUG=true (set in .env.development.local).
// Deployed builds leave it unset, so they only log real problems via console.warn/console.error.
const enabled = process.env.REACT_APP_DEBUG === 'true';
const noop = () => {};

export const log = {
  // Bound so DevTools still shows the caller's file and line, not this one
  debug: enabled ? console.log.bind(console) : noop,
};
